import { NgModule } from '@angular/core';
import { PusherService } from './pusher.service';

@NgModule({
  providers: [PusherService],
})
export class PusherServiceModule {}
